/*
 * @Author: cmchiu
 * @Date: 2023-03-21 15:01:44
 * @LastEditTime: 2023-12-06 11:33:43
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \IACMP\IACMP_Client\src\router\index.js
 *
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import routes from './routes.js'

Vue.use(VueRouter)

/**
 * 解决报错问题：报错显示是路由重复
 * Error: Avoided redundant navigation to current location
 */
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const createRouter = () =>
    new VueRouter({
        mode: 'hash',
        base: process.env.BASE_URL,
        // scrollBehavior: () => ({ y: 0 }),
        // scrollBehavior,
        routes: [...routes],
    })

const router = createRouter()

router.beforeEach(async (to, from, next) => {
    const hasMenus = store.getters.menusRoutes
    if (hasMenus && hasMenus.length > 0) {
        next()
    } else {
        try {
            // 頁面刷新後, 重新获取路由
            const accessRoutes = await store.dispatch('permission/generateRoutes')
            for (let route of accessRoutes) {
                router.addRoute(route)
            }
            next({ ...to, replace: true })
        } catch (error) {
            next(`/home`)
        }
    }
})

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}

export default router
